import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import moment from "moment";
import BasicInformation from "./Steps/BasicInformation";
import SubstitutionList from "./Steps/SubstitutionList";
import SummaryList from "./Steps/SummaryList";
import Calculate from "./Steps/Calculate";
import { useCommunityList, useSaveTravelCost, useSubstitutorList, useSubstitutorShifts, useTravelCostData, useTravelCostSummary } from "Api/Coordinator/TravelCost";



const Default = () => {

    const [formDataState, setFormDataState] = useState({
        communityList: [],
        travelData: '',
        startDate: '',
        endDate: '',
        daytypes: [],
        email: 1,
        iTravelPdf: 1,
        pdf: 1,
        vKm: 0.00,
        vPrice: 0.00,
        vBedrag: "0.00",
        substitutorList: [],
        selectedIds: [],
        idsToSend: [],
        substitutorShiftData: '',
        editable: null,
        automatic: null,
        vCorrect: "0.00",
        messageVervanger: '',
        messageSalaris: '',
        travelExpenseList: [],
        summary: [],
        vTravelAdminMailAddress: ''
    });

    const [step, setStep] = useState('step1')
    const [communityId, setCommunityId] = useState('')
    const [selectedTravel, setSelectedTravel] = useState();

    const [shiftListLoading, setShiftListLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    let currentAdminId;
    const [substitutorssData, setSubstitutorssData] = useState();
    const [summary, setSummary] = useState([]);
    const [pageTotals, setPageTotals] = useState({});
    const[totalCount,setTotalCount]=useState(0)
    const substitutorListMutation = useSubstitutorList(communityId);
    const substitutorShiftsMutation = useSubstitutorShifts();
    const saveTravelCostMutation = useSaveTravelCost();
    const travelCostSummaryMutation = useTravelCostSummary();

    useEffect(() => {


        if (formDataState.daytypes?.length > 0) {
            getSubstitutorList();
        }
    }, [formDataState.daytypes]);

    useEffect(() => {
        const currentAdminId = formDataState.selectedIds?.[currentIndex];
        if (!currentAdminId) return;

        const rowTotalSum =
            formDataState?.substitutorShiftData?.list?.reduce(
                (sum, item) => sum + Number(item.rowTotal || 0),
                0
            ) || 0;

        const vCorrectValue = Number(formDataState?.vCorrect || 0);

        const currentTotal = rowTotalSum + vCorrectValue;
        setPageTotals(prev => {
            const updated = {
                ...prev,
                [currentAdminId]: currentTotal
            };
            return updated;
        });

    }, [formDataState?.substitutorShiftData?.list, formDataState?.vCorrect, currentIndex]);


    const { data: communityResponse } = useCommunityList();
    const communityList = communityResponse?.communityList || [];


    useEffect(() => {
        if (!communityList.length) return;

        setFormDataState(prev => ({
            ...prev,
            communityList
        }));
    }, [communityList]);

    useEffect(() => {
        const initialSelectedTravel = [];
        Object.keys(formDataState.travelData && formDataState.travelData.daytypes).forEach((key) => {
            const dayType = formDataState.travelData.daytypes[key];
            initialSelectedTravel[key] = {
                id: dayType.id,
                value: dayType.travel,
                name: dayType.desc
            };
        });
        setSelectedTravel(initialSelectedTravel);
    }, [formDataState.travelData])

    const {
        data: travelCostData,
        isLoading: travelCostLoading,
        error: travelCostError,
    } = useTravelCostData(communityId);


    useEffect(() => {
        if (!travelCostData) return;

        setFormDataState(prev => ({
            ...prev,
            travelData: travelCostData.data,
            vPrice: travelCostData.data.communityData.vPrice,
            vKm: travelCostData.data.communityData.vKm,
            vBedrag: travelCostData.data.communityData.vBedrag ?? 9.35,
            email: travelCostData.data.communityData.iTravelEmail,
            pdf: travelCostData.data.communityData.iTravelPdf,
            vTravelAdminMailAddress:
                travelCostData.data.communityData.vTravelAdminMailAddress,
            daytypes: travelCostData.data.daytypes,
        }));
    }, [travelCostData]);



    useEffect(() => {
        if (formDataState.daytypes?.length > 0) {
            getSubstitutorList();
        }
    }, [formDataState.daytypes]);

    const getSubstitutorList = () => {

        if (!formDataState.startDate || !formDataState.endDate) {
            return;
        }
        const dayparts = formDataState.daytypes.map(d => ({
            id: d.id,
            value: d.value ?? d.travel ?? 0
        }));

        const payload = {
            startDate: formDataState.startDate,
            endDate: formDataState.endDate,
            iTravelPdf: formDataState.iTravelPdf,
            dayparts
        };

        substitutorListMutation
            .trigger({
                data: {
                    communityId,
                    ...payload
                }
            })
            .then((response) => {
                if (response.status === true) {
                    setFormDataState(prevState => {
                        const updatedState = { ...prevState, substitutorList: response.substitutorList, schoolLists: response.schoolLists };
                        const adminIds = response.substitutorList.map(item => item.iAdminId);
                        return {
                            ...updatedState, selectedIds: adminIds
                        };

                    });
                    setTotalCount(response?.totalCount)
                    setShiftListLoading(false)
                }
            })
            .catch((error) => console.error(error));
    };

    const calculateSubTotal = (data) => {
        if (!data || !data.list) return 0;
        const total = data.list.reduce((total, day) => {
            const rowTotal = day.RowTotal || 0;
            return total + Number(rowTotal);
        }, 0);

        return total;
    };


    const getSubstitutorShifts = (index, indexAftercalculation = null) => {
        currentAdminId = indexAftercalculation !== null ? indexAftercalculation : formDataState.selectedIds[index];
        const dataToSend = {
            iCommunityId: communityId,
            startDate: formDataState.startDate,
            iAdminId: [
                currentAdminId
            ],
            endDate: formDataState.endDate,
            vKm: formDataState.vKm,
            vPrice: parseFloat((formDataState.vPrice).replace(',', '.')),
            vBedrag: formDataState.vBedrag
        }

        substitutorShiftsMutation
            .trigger({
                data: dataToSend
            })
            .then((response) => {

                if (response.status === true) {
                    const substitutorShiftData = response.data;
                    const updatedList = substitutorShiftData.list.map(day => {
                        const updatedDay = { ...day };
                        if (updatedDay) {
                            updatedDay.vPrice = parseFloat((formDataState.vPrice).replace(',', '.'));
                            updatedDay.originalDistance = updatedDay.distance;
                            updatedDay.originalKmInReturnReimbursed = updatedDay.kmInReturnReimbursed;
                            updatedDay.rowTotal = updatedDay.RowTotal
                        }
                        return updatedDay;
                    });
                    const updatedSubstitutorShiftData = {
                        ...substitutorShiftData,
                        list: updatedList,
                        subTotal: calculateSubTotal(substitutorShiftData),
                        total: 0
                    };


                    setFormDataState({
                        ...formDataState,
                        substitutorShiftData: updatedSubstitutorShiftData,
                        messageVervanger: '',
                        messageSalaris: '',
                        vCorrect: '0.00'
                    });
                    shiftsToSend(updatedSubstitutorShiftData, currentAdminId);

                }
            })
            .catch((error) => console.error(error))
            .finally(() => {

                setShiftListLoading(false);
            });
    };

    const getVDate = (date, shift, schoolName, id) => {
        var getDay = new Date(moment(date, 'DD-MM-YY')).toLocaleDateString("nl-NL", { weekday: 'long' });
        getDay = getDay.charAt(0).toUpperCase() + getDay.slice(1)

        const dateObject = new Date(moment(date, 'DD-MM-YY').format('DD MMMM YYYY'));
        var getDate = dateObject.toLocaleDateString("nl-NL", { day: '2-digit', month: 'long', year: 'numeric' });

        var vDate = getDay + " " + getDate + "||" + shift + "||" + schoolName + "||" + id;
        return vDate;
    }

    const shiftsToSend = (data, currentAdminId) => {

        if (!data?.list) {
            return;
        }
        const shiftsData = data.list.map(item => {
            return {
                iSubsDateId: item.iSubsDateId,
                vDate: getVDate(item.vSubsDate, item.vShift, item.vSchoolName, item.iSchoolId),
                vCode: item.vCode || '',
                iSchoolId: item.iSchoolId || 0,
                iDistance: Number(item.distance) || 0,
                vPrice: item.vPrice || 0.00,
                kmInReturnReimbursed: Number(item.kmInReturnReimbursed || 0.00),
                rowTotal: Number(item.rowTotal || 0.00),
                repay: item.repay || 0.00,

            };
        });
        substitutorsToSend(data, shiftsData, currentAdminId);

    };


    const substitutorsToSend = (data, shift, currentAdminId) => {
        const newSubstitutor = {
            iDistanceTotal: data.totalAfstand,
            subtotal: data.subTotal,
            vCorrect: Number(formDataState.vCorrect),
            total: Number(data.subTotal + Number(formDataState.vCorrect)).toFixed(2),
            iSubstitutorAdminId: currentAdminId,
            messageVervanger: formDataState.messageVervanger,
            messageSalaris: formDataState.messageSalaris,
            totalRepay: Number(data.totalRepay),
            shifts: shift
        }
        setSubstitutorssData(newSubstitutor);
        setShiftListLoading(false)
    }


    const saveTravelcostData = async () => {
        const newSelectedTravel = selectedTravel?.map(item => {
            const { name, ...rest } = item;
            return rest;
        }) || [];
        const currentAdminId =
            formDataState.selectedIds?.[currentIndex];
        const isLastIndex = currentIndex === formDataState.selectedIds.length - 1;
        const grandTotal = parseFloat(
            Object.values(pageTotals || {}).reduce((sum, t) => sum + t, 0).toFixed(2)
        );
        const combinedAdminIds = Object.entries(pageTotals || {}).map(([id, total]) => ({
            iSubstitutorAdminId: Number(id),
            total: parseFloat(total.toFixed(2))
        }));


        const dataToSend = {
            iCommunityId: communityId,
            vKm: Number(formDataState.vKm),
            vPrice: parseFloat((formDataState.vPrice || '0').replace(',', '.')),
            vBedrag: parseFloat(String(formDataState.vBedrag || '0').replace(',', '.')),
            automatic: formDataState.automatic,
            startDate: formDataState.startDate,
            endDate: formDataState.endDate,
            sendEmail: formDataState.email,
            savePdf: formDataState.pdf,

            iSubstitutorAdminIds:
                formDataState.automatic == 1
                    ? formDataState.selectedIds || []
                    : currentAdminId
                        ? [currentAdminId]
                        : [],

            substitutors: substitutorssData,
            vTravelAdminMailAddress: formDataState.vTravelAdminMailAddress,
            ...(isLastIndex && {
                combinedAdminIds: combinedAdminIds,
                grandTotal
            })

        };

        try {
            return await saveTravelCostMutation.trigger({
                data: dataToSend
            });
        } catch (error) {
            return { status: false };
        }
    };


    const getTravelCostSummary = () => {
        const dataToSend = {
            iCommunityId: communityId,
            substitutors: formDataState.selectedIds,

        }
        travelCostSummaryMutation
            .trigger({
                data: dataToSend
            })
            .then((response) => {
                if (response.status === true) {
                    setSummary(response?.data);
                    setShiftListLoading(false)
                }
            })
            .catch((error) => console.error(error));
    };

    return (
        <Fragment>
            <TransitionOnLoad>
                {
                    (step == 'step1') ?
                        <BasicInformation getSubstitutorList={getSubstitutorList} communityId={communityId} setCommunityId={setCommunityId} setStep={setStep}
                            formDataState={formDataState} setFormDataState={setFormDataState} selectedTravel={selectedTravel} setSelectedTravel={setSelectedTravel} /> :
                        (step == 'step2') ?
                            <SubstitutionList formDataState={formDataState} setStep={setStep} getTravelCostSummary={getTravelCostSummary} getSubstitutorList={getSubstitutorList}
                                setFormDataState={setFormDataState} shiftListLoading={shiftListLoading} count={totalCount} /> :
                            (step == 'step3') ?
                                <SummaryList setStep={setStep} summary={summary} saveTravelcostData={saveTravelcostData} selectedTravel={selectedTravel} count={totalCount} setSubstitutorssData={setSubstitutorssData}
                                    shiftListLoading={shiftListLoading} formDataState={formDataState} getSubstitutorShifts={getSubstitutorShifts} getTravelCostSummary={getTravelCostSummary} /> :

                                <Calculate formDataState={formDataState} setFormDataState={setFormDataState} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} saveTravelcostData={saveTravelcostData}
                                    getSubstitutorShifts={getSubstitutorShifts} shiftListLoading={shiftListLoading} setShiftListLoading={setShiftListLoading} substitutorssData={substitutorssData}
                                    setSubstitutorssData={setSubstitutorssData} />
                }
            </TransitionOnLoad>
        </Fragment>
    )
};

export default Default;
